var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      attrs: {
        visible: _vm.visible,
        width: "430px",
        "custom-class": "balance-days-warning-dialog",
        "show-close": false,
        "close-on-click-modal": false,
        "close-on-press-escape": false,
        "append-to-body": "",
      },
    },
    [
      _c("div", { staticClass: "warning-content" }, [
        _c("div", { staticClass: "warning-icon" }, [_vm._v("!")]),
        _c("h2", [_vm._v("账户余额不足提醒")]),
        _c("div", { staticClass: "balance-label" }, [_vm._v("当前账户余额")]),
        _c("div", { staticClass: "balance" }, [
          _vm._v("¥" + _vm._s(_vm.formatMoney(_vm.detail.balance))),
        ]),
        _c("div", { staticClass: "metrics" }, [
          _c("div", [
            _c("span", [_vm._v("近30天日均消耗")]),
            _c("strong", [
              _vm._v(
                "¥" +
                  _vm._s(_vm.formatMoney(_vm.detail.averageDailyConsumption))
              ),
            ]),
          ]),
          _c("div", [
            _c("span", [_vm._v("预计可使用")]),
            _c("strong", { staticClass: "danger" }, [
              _vm._v(_vm._s(_vm.detail.availableDays || 0) + " 天"),
            ]),
          ]),
          _c("div", [
            _c("span", [_vm._v("预计耗尽日期")]),
            _c("strong", { staticClass: "danger" }, [
              _vm._v(_vm._s(_vm.exhaustionDate)),
            ]),
          ]),
        ]),
        _c("div", { staticClass: "progress" }, [
          _c("div", { style: { width: _vm.progressWidth + "%" } }),
        ]),
        _c("div", { staticClass: "warning-text" }, [
          _vm._v(
            "按当前消耗速度，余额预计将于 " +
              _vm._s(_vm.detail.estimatedExhaustionDate) +
              " 耗尽"
          ),
        ]),
        _c("p", [_vm._v("为避免影响机构正常使用，请及时充值。")]),
        _c(
          "div",
          { staticClass: "actions" },
          [
            _c(
              "el-button",
              {
                on: {
                  click: function ($event) {
                    return _vm.$emit("close")
                  },
                },
              },
              [_vm._v("我知道了")]
            ),
          ],
          1
        ),
        _c("small", [
          _vm._v("本提醒由系统统一规则触发 · 可用天数不足时自动弹出"),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }